import React, { useState } from "react";

const SignUp = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <section className="auth d-flex">
      {/* Left Section */}
      <div className="auth-left bg-main-50 flex-center p-24">
        <img src="assets/images/thumbs/auth-img2.png" alt="Auth Illustration" />
      </div>

      {/* Right Section */}
      <div
        className="auth-right py-40 px-24 flex-center flex-column"
        style={{ backgroundColor: "white" }}
      >
        <div className="auth-right__inner mx-auto w-100">
          <a href="index.html" className="auth-right__logo">
            <img src="assets/images/logo/logo.png" alt="Logo" />
          </a>
          <h2 className="mb-8">Sign Up</h2>
          <p className="text-gray-600 text-15 mb-32">
            Please sign up to your account and start the adventure
          </p>

          {/* Form */}
          <form>
            <div className="mb-24">
              <label htmlFor="username" className="form-label mb-8 h6">
                Username
              </label>
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control py-11 ps-40"
                  id="username"
                  placeholder="Type your username"
                />
                <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex">
                  <i className="ph ph-user"></i>
                </span>
              </div>
            </div>

            <div className="mb-24">
              <label htmlFor="email" className="form-label mb-8 h6">
                Email
              </label>
              <div className="position-relative">
                <input
                  type="email"
                  className="form-control py-11 ps-40"
                  id="email"
                  placeholder="Type your email address"
                />
                <span className="position-absolute top-50 translate-middle-y ms-16 text-gray-600 d-flex">
                  <i className="ph ph-envelope"></i>
                </span>
              </div>
            </div>

            <div className="mb-24">
              <label htmlFor="current-password" className="form-label mb-8 h6">
                Current Password
              </label>
              <div className="position-relative">
                <input
                  type={passwordVisible ? "text" : "password"}
                  className="form-control py-11 ps-40"
                  id="current-password"
                  placeholder="Enter Current Password"
                />
                <span
                  className="position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y"
                  onClick={togglePasswordVisibility}
                >
                  {passwordVisible ? (
                    <i className="ph ph-eye"></i>
                  ) : (
                    <i className="ph ph-eye-slash"></i>
                  )}
                </span>
              </div>
              <span className="text-gray-900 text-15 mt-4">
                Must be at least 8 characters
              </span>
            </div>

            <div className="mb-32 flex-between flex-wrap gap-8">
              <div className="form-check mb-0 flex-shrink-0">
                <input
                  className="form-check-input flex-shrink-0 rounded-4"
                  type="checkbox"
                  id="remember"
                />
                <label
                  className="form-check-label text-15 flex-grow-1"
                  htmlFor="remember"
                >
                  Remember Me
                </label>
              </div>
              <a
                href="forgot-password.html"
                className="text-main-600 hover-text-decoration-underline text-15 fw-medium"
              >
                Forgot Password?
              </a>
            </div>

            <button type="submit" className="btn btn-main rounded-pill w-100">
              Sign Up
            </button>

            <p className="mt-32 text-gray-600 text-center">
              Already have an account?{" "}
              <a
                href="sign-in.html"
                className="text-main-600 hover-text-decoration-underline"
              >
                Log In
              </a>
            </p>

            <div className="divider my-32 position-relative text-center">
              <span className="divider__text text-gray-600 text-13 fw-medium px-26 bg-white">
                or
              </span>
            </div>

            {/* Social Links */}
            <ul className="flex-align gap-10 flex-wrap justify-content-center">
              <li>
                <a
                  href="https://www.facebook.com"
                  className="w-38 h-38 flex-center rounded-6 text-facebook-600 bg-facebook-50 hover-bg-facebook-600 hover-text-white text-lg"
                >
                  <i className="ph-fill ph-facebook-logo"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.twitter.com"
                  className="w-38 h-38 flex-center rounded-6 text-twitter-600 bg-twitter-50 hover-bg-twitter-600 hover-text-white text-lg"
                >
                  <i className="ph-fill ph-twitter-logo"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com"
                  className="w-38 h-38 flex-center rounded-6 text-google-600 bg-google-50 hover-bg-google-600 hover-text-white text-lg"
                >
                  <i className="ph ph-google-logo"></i>
                </a>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignUp;
